import AccountInfoCard from '@/components/Settings/AccountPage/AccountInfoCard';
import PasswordCard from '@/components/Settings/AccountPage/PasswordCard';
import Flex from '@/components/ui/Flex';

export default function AccountPage() {
  return (
    <Flex.Col gap="5">
      <AccountInfoCard />
      <PasswordCard />
    </Flex.Col>
  );
}
